import { createContext } from 'react'

const ScreenWidthContext = createContext()

export default ScreenWidthContext
